<template>
    <div id="nav">
    <b-navbar toggleable="lg"  type="dark">
        <b-navbar-brand>
            <router-link to="/">
                <img src="https://i.postimg.cc/jjbJn7ys/favicon.png" class="d-inline-block align-top" alt="">
                <b-nav-text>迷．糜</b-nav-text>
            </router-link>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-navbar-nav right>
                    <b-nav-item-dropdown text="情緒勒索" id="computer">
                        <b-dropdown-item><router-link to="/FogText">文字版</router-link></b-dropdown-item>
                        <b-dropdown-item><router-link to="/Fog">動畫版</router-link></b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item id="cellphone"><router-link to="/FogText">情緒勒索</router-link></b-nav-item>
                    <b-nav-item><router-link to="/Detection">自我檢測</router-link></b-nav-item>
                    <b-nav-item><router-link to="/Information">相關資訊</router-link></b-nav-item>
                    <b-nav-item> <router-link to="/About">關於我們</router-link></b-nav-item>
                </b-navbar-nav>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</div>
</template>
<script>
export default {
    name: 'Navbar'
};
</script>

<style>

#nav img{
    width: 50px;
    height: 50px;
}


a.nav-link{
    font-size: 20px;
}
.navbar-dark .navbar-nav .nav-link,.navbar-dark .navbar-text{
    color: #fff;
    font-weight: bold;
    background-color: rgba(0,0,0,0);
}
.navbar-dark .navbar-nav .nav-link:hover {
    color: #EEB868!important;
}
/* .navbar-dark .navbar-nav .nav-link:focus {
    color: #EEB868;
} */


@media (min-width: 1001px) { 
    #cellphone{
        display: none;
    } 
}

/* phones */
@media (max-width: 1000px) { 
    #computer{
        display: none;
    }
    
}
.dropdown-menu{
    background-color: #598392;
    color: #fff;
}   

.dropdown-item:focus,.nav-item:focus{
    color:#EEB868;
    outline: none;

}
.dropdown-item:hover{
    background-color:rgba(255,255,255,0.1);
    color:#EEB868;
}

a{
    outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/Navbar.vue